module.exports = __webpack_public_path__ + "img/arrow-left.1ad9d28e.svg";